import categories from "./categories.json";
const { gameCategories, printableCategories, gradeCategories, printableCategoryNavNames } = categories;

export { gameCategories, printableCategories, gradeCategories, printableCategoryNavNames };
